/**
 * Tabs of the Account page. Lives outside `Account.tsx` so deep-links can name a tab by the enum
 * instead of duplicating its string — a deep-link that points at a tab value which no longer
 * exists silently falls back to General, which reads as the link doing nothing (PREC-3805).
 */
export enum AccountTabs {
	GENERAL = "GENERAL",
	CONNECTED_ACCOUNTS = "CONNECTED_ACCOUNTS",
	LINKEDIN_CONNECTIONS = "LINKEDIN_CONNECTIONS",
	NOTIFICATIONS = "NOTIFICATIONS",
}

export const isAccountTab = (value: string | null): value is AccountTabs =>
	!!value && Object.values(AccountTabs).includes(value as AccountTabs);
